import React, { useEffect, useState } from 'react'
import BaggageForm, {
  BaggageFormInputDataType,
  BaggageFormOutputDataType,
} from '../components/forms/BaggageForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type BaggagePageProps = {
  transitions: BaggagePageTransitions
}

export type BaggagePageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const BaggagePage = (props: BaggagePageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [dispatch, ifEqual])

  const { fetch: fetchData } = useGetData({})

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleBaggagePageBack = () => {
    //history.push(pathToClaimant)
    props.transitions.goBack()
  }

  const handleBaggagePageSubmitted = (value: BaggageFormOutputDataType) => {
    if (state.loadedCaseReportResp == null) {
      throw new Error('Illegal state -- no loadedCaseReportResp')
    }
    const origCaseReportResp: CaseReportRespType = state.loadedCaseReportResp
    const newCaseReportDataResp: CaseReportRespType = {
      ...origCaseReportResp,
      caseBA: value.caseBA,
      caseCommon: value.caseCommon,
    }

    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 4 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  function handleBaggagePageDataChanged(isChanged: boolean): void {
    setIfEqual(isChanged)
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToBankAccount)
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const baggageFormData: BaggageFormInputDataType = {
    caseBA: state.loadedCaseReportResp?.caseBA ?? null,
    caseCommon: state.loadedCaseReportResp?.caseCommon ?? null,
  }

  return (
    <BaggageForm
      caseReportId={state.caseReportId!}
      data={baggageFormData}
      isPageConfirmInProgress={pending}
      errorMessage={state.error}
      onPageContinue={handleBaggagePageSubmitted}
      onPageBack={handleBaggagePageBack}
      notifyDataChanged={handleBaggagePageDataChanged}
    />
  )
}

export default BaggagePage
